import { configureStore, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "types/types";
import authReducer from "./authSlice";
import adminReducer from "./adminSlice";
import { api } from "./api";
import { setupListeners } from "@reduxjs/toolkit/query";

const initialState: GlobalState = {
  mode: "light",
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

export const { setMode } = globalSlice.actions;

export default globalSlice.reducer;

export const store = configureStore({
  reducer: {
    global: globalSlice.reducer,
    auth: authReducer,
    admin: adminReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
